// Update every summer.

// Title for the box (Youth vs. Adult)
export const siTitle = "NYLIA BALLET SUMMER INTENSIVES";
export const youthCaption = `Our youth ballet intensive is an immersive and rigorous training
  program designed to accelerate the development of young ballet
  dancers.`;
export const adultCaption = "";

export const applicationLink = "https://form.jotform.com/260704835107151";

export const intensiveDates = "July 13-25";
export const week1Dates = "Monday, July 13 - Friday, July 17";
export const week2Dates = "Monday, July 20 - Friday, July 24";

export const concertoTitle = "Summer Concerto";
export const concertoDate = "Saturday, July 25";
export const concertoTime = "8 pm";

export const intensiveCaption = `Our youth ballet intensive is an immersive and rigorous training
  program designed to accelerate the development of young ballet
  dancers. This intensive offers a focused environment where aspiring
  dancers can hone their skills, expand their repertoire, and refine
  their technique under the guidance of our experienced instructors.
  The youth ballet intensive offers young dancers valuable
  opportunities to immerse themselves in ballet, refine their
  technique, expand their artistic horizons, and form lasting
  connections with their peers and mentors who share their passion for
  dance.`;

export const levelOptions = {
  petiteBallet: {
    levelTitle: "PETITE BALLET (Ages 3-7)",
    levelDesc:
      "Petite Ballet is a joyful introduction to dance for our youngest movers. In a fun, nurturing environment, children explore music, movement, and basic ballet steps while building confidence, coordination, and a love for dance. No prior experience is needed, just curiosity and a smile!",
    levelTimes: "8:30 am - 11:30 am",
    tuition: "$350",
    attire: [
      {
        title: "Classical Ballet Attire",
        bullets: [
          "Solid black leotard",
          "Ballet pink or skin-tone tights",
          "Ballet shoes, must match tights",
          "Hair neatly secured in a slicked-back ballet bun, with all hair out of the face",
          "No jewelry",
        ],
      },
      {
        title: "Traditional Boys’ Ballet Attire",
        bullets: [
          "White t-shirt",
          "Black ballet tights",
          "Black ballet slippers",
          "Hair neat and secured away from the face",
        ],
      },
    ],
    curriculum: [
      "Classical Ballet Technique",
      "Creative Movement & Musicality",
      "Flexibility & Conditioning",
      "Ballet Stories",
      "Improvisation & Imagination",
      "Summer Concerto Rehearsals",
      "Arts & Crafts",
      "Plus level-specific classes tailored to your training",
    ],
  },
  juniorBallet: {
    levelTitle: "JUNIOR BALLET (Ages 8-13)",
    levelDesc:
      "Junior Ballet offers focused classical training for dancers ready to refine their technique, develop strength, and grow in artistry. Classes emphasize precision, musicality, and performance skills in a supportive environment, giving young dancers the opportunity to challenge themselves and reach their full potential while fostering a lifelong love of ballet.",
    levelTimes: "8:30 am - 1:00 pm",
    tuition: "$350",
    attire: [
      {
        title: "Classical Ballet Attire",
        bullets: [
          "Solid black leotard",
          "Ballet pink or skin-tone tights",
          "Ballet shoes, must match tights",
          "Hair neatly secured in a slicked-back ballet bun, with all hair out of the face",
          "No jewelry",
        ],
      },
      {
        title: "Traditional Boys’ Ballet Attire",
        bullets: [
          "White t-shirt",
          "Black ballet tights",
          "Black ballet slippers",
          "Hair neat and secured away from the face",
        ],
      },
    ],
    curriculum: [
      "Classical Ballet Technique",
      "Pointe",
      "Choreography",
      "Variations",
      "Repertoire",
      "Improvisation & Musicality",
      "Flexibility & Conditioning",
      "Summer Concerto Rehearsals",
      "Plus level-specific classes tailored to your training",
    ],
  },
  preProfessional: {
    levelTitle: "PRE-PROFESSIONAL (Teen & Adult)",
    levelDesc:
      "This intensive is designed for intermediate and advanced teen and adult dancers seeking rigorous classical training. Students focus on refining technique, building strength and stamina, and developing artistry and performance skills. Classes challenge dancers in a supportive, focused environment, offering the opportunity to grow technically and artistically while preparing for higher-level ballet study.",
    levelTimes: "11:30 am - 5:30 pm",
    tuition: "$350",
    attire: [
      {
        title: "Classical Ballet Attire",
        bullets: [
          "Leotard",
          "Ballet pink or skin-tone tights",
          "Ballet shoes, must match tights",
          "Pointe shoes, if applicable",
          "Hair neatly secured in a slicked-back ballet bun, with all hair out of the face",
          "No jewelry",
        ],
      },
      {
        title: "Traditional Men’s Ballet Attire",
        bullets: [
          "White t-shirt",
          "Black ballet tights",
          "Black ballet slippers",
          "Hair neat and secured away from the face",
        ],
      },
    ],
    curriculum: [
      "Classical Ballet Technique",
      "Pointe",
      "Men's Technique",
      "Pas de Deux/Partnering",
      "Choreography & Improvisation",
      "Variations",
      "Repertoire",
      "Flexibility & Conditioning",
      "Plus level-specific classes tailored to your training",
    ],
  },
  beginnerBallet: {
    levelTitle: "BEGINNER BALLET (Teen & Adult)",
    levelDesc:
      "This intensive is for teens and adults who are new to ballet or returning to dance. Students will build a strong foundation in classical technique, improve strength and flexibility, and gain confidence in movement. Classes are taught in a supportive, encouraging environment where everyone can enjoy the beauty and artistry of ballet at their own pace.",
    levelTimes: "5:30 pm - 9:30 pm",
    tuition: "$350",
    attire: [
      {
        title:
          "Comfortable clothing that allows for ease of movement is encouraged. Attire should still be fitted enough for instructors to see alignment and movement clearly.",
        bullets: [
          "Leotard (any color or style) or a fitted workout top",
          "Leggings, tights, or fitted athletic wear",
          "Ballet slippers",
          "Hair neatly secured in a slicked-back ballet bun, with all hair out of the face",
          "Optional: light warm-up layers (such as shorts or a wrap sweater)",
        ],
      },
    ],
    curriculum: [
      "Classical Ballet Technique",
      "Variations",
      "Repertoire",
      "Choreography & Improvisation",
      "Flexibility & Conditioning",
      "Summer Concerto Rehearsals",
      "Plus level-specific classes tailored to your training",
    ],
  },
};

export const siSections = [
  { title: `Youth Intensive`, link: `siYouthTeenAdultSection` },
  { title: `Teen & Adult Intensive`, link: `siYouthTeenAdultSection` },
  { title: `Scholarships`, link: `siTuitionSection` },
  { title: `Tuition & Fees`, link: `siTuitionSection` },
  { title: `Q&A's`, link: `qaSection` },
];

export const qAndA = [
  {
    q: "Do I need ballet experience to participate?",
    a:
      "Not at all! Our Summer Intensive is open to everyone, from absolute beginners to experienced dancers, and we offer different levels so each person can find the class that feels right for them.",
  },
  {
    q: "How do I register?",
    a:
      "To register, simply complete the application form and you will receive a confirmation email from us. From there, we’ll guide you through the next steps for tuition payment and share all the information you’ll need for the Summer Intensive.",
    link: applicationLink,
    linkLabel: "apply now",
  },

  {
    q: "Is it possible to attend a portion of one session?",
    a:
      "The Summer Intensive is designed as a full program, and full payment is required for all students, even if a day is missed. While we understand scheduling conflicts can happen, partial attendance or partial payments are not accepted. We encourage everyone to plan for the full session to get the complete experience, and we’re always happy to answer questions if you’re unsure which dates or levels are right for you.",
  },
  {
    q: "Will there be a performance at the end of the session?",
    a:
      "Yes! The Summer Intensive concludes with “Summer Concerto,” presented by the Nylia Ballet Company on Saturday, July 25. All dancers will participate, and families are warmly invited to attend and celebrate the students’ hard work and progress.",
  },
  {
    q: "Are scholarships or financial aid available? ",
    a:
      "A limited number of merit-based scholarships are available and are awarded on a case-by-case basis at the time of audition. Families are encouraged to contact us if they have questions or need guidance about eligibility.",
  },
  {
    q: "Are there refunds if a student cannot attend?",
    a:
      "All tuition payments are non-refundable, as the Summer Intensive is designed as a full program. We encourage families to carefully review the schedule and plan accordingly before registering.",
  },
  {
    q: "What should students wear to class?",
    a:
      "All students are expected to wear proper classical ballet attire. You can see exactly what to wear for your level by clicking the dropdown for your section in the 'Nylia Ballet Summer Intensives' area above, this has all the details for each age group and level.",
  },
  {
    q: "Do students need to bring their own lunch?",
    a:
      "Yes, all students should bring a lunch, snack, and water each day to stay energized and hydrated during the Summer Intensive.",
  },
  {
    q: "What should students bring each day?",
    a:
      "Bring your ballet shoes, the right attire for your level, water, and a snack or lunch. You can also bring a yoga mat or anything that helps you feel comfortable. Full details are in the dropdown under your level above.",
  },
];
